
import { useAuth as useAuthProvider } from "@/components/AuthProvider"

export const useAuth = () => {
  const context = useAuthProvider()
  
  return {
    user: context.session?.user || null,
    signOut: async () => {
      // Implementation would go here
      console.log("Sign out")
    },
    session: context.session,
    loading: context.loading
  }
}
